// extracted by mini-css-extract-plugin
export var standaloneTable = "_s-0";
export var standaloneTableWithBodyFill = "_s-1";
export var withExtraHeader = "_s-2";